var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-detail-item" },
    [
      _c(
        "div",
        { staticClass: "contact-detail-item-details" },
        [
          _vm.field === "vipCustomer"
            ? [
                _c(
                  "div",
                  { staticClass: "contact-detail-item-input vip-customer" },
                  [
                    _c(
                      "div",
                      { staticClass: "contact-detail-item-input-label" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                  delay: [600, 0],
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                              },
                            ],
                            class: {
                              "material-icons": true,
                              vip: _vm.contact.vipCustomer,
                            },
                            attrs: { content: "★ VIP Customer" },
                          },
                          [
                            _vm._v(
                              "\n                        star\n                    "
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.label) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "contact-detail-item-input-val" },
                      [
                        _c("a-switch", {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                delay: [600, 0],
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                            },
                          ],
                          attrs: {
                            checked: _vm.value,
                            content: _vm.getSwitchTippyValue(),
                          },
                          on: { change: _vm.saveVipCustomer },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "contact-detail-item-icon" },
                  [_vm._t("icon")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "contact-detail-item-input" }, [
                  _c(
                    "div",
                    { staticClass: "contact-detail-item-input-label" },
                    [_vm._v(_vm._s(_vm.label))]
                  ),
                  _vm._v(" "),
                  _vm.value != null
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                delay: [600, 0],
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                            },
                          ],
                          staticClass: "contact-detail-item-input-val",
                          attrs: { content: _vm.getTippyValue() },
                        },
                        [
                          _vm.field === "tags"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "tags-container" },
                                  _vm._l(_vm.mappedTags, function (tag) {
                                    return _c(
                                      "span",
                                      {
                                        key: tag._id,
                                        staticClass: "tag-label",
                                        style: _vm.getTagStyle(tag.color),
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "remove-tag",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeTag(tag._id)
                                              },
                                            },
                                          },
                                          [_vm._v("×")]
                                        ),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(tag.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.value) +
                                    "\n                    "
                                ),
                              ],
                        ],
                        2
                      )
                    : _vm.showAdd
                    ? _c(
                        "div",
                        {
                          staticClass: "contact-detail-item-input-val add-link",
                          on: { click: _vm.showAddModal },
                        },
                        [
                          _vm._v(
                            "\n                    + Ekle\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.value != null && _vm.inputType !== "switch"
        ? _c(
            "div",
            { staticClass: "contact-detail-item-actions" },
            [
              _vm.showEdit
                ? _c(
                    "button",
                    {
                      staticClass: "action-button edit-btn",
                      on: { click: _vm.handleEdit },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("edit"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showDelete
                ? _c(
                    "button",
                    {
                      staticClass: "action-button delete-btn",
                      on: { click: _vm.showDeleteModal },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("delete"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showCopy
                ? _c(
                    "button",
                    {
                      staticClass: "action-button copy-btn",
                      on: { click: _vm.copyValue },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("content_copy"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("actions"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editModal && _vm.field === "vipCustomer"
        ? _c(
            "Modal2",
            {
              attrs: { title: "VIP Customer", showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { id: "vip-customer-modal-content" } },
                [
                  _c("div", { staticClass: "description" }),
                  _vm._v(" "),
                  _c("a-switch", {
                    model: {
                      value: _vm.editedValue,
                      callback: function ($$v) {
                        _vm.editedValue = $$v
                      },
                      expression: "editedValue",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "modal-actions" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          on: {
                            click: function ($event) {
                              _vm.editModal = false
                            },
                          },
                        },
                        [_vm._v("Vazgeç")]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        { attrs: { primary: "" }, on: { click: _vm.saveEdit } },
                        [_vm._v("Güncelle")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editModal && !_vm.isSpecialField
        ? _c(
            "Modal2",
            {
              attrs: { title: "Düzenle: " + _vm.label, showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c("div", { attrs: { id: "contact-property-modal-content" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedValue,
                      expression: "editedValue",
                    },
                  ],
                  attrs: { placeholder: "Yeni değer girin" },
                  domProps: { value: _vm.editedValue },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.editedValue = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        on: {
                          click: function ($event) {
                            _vm.editModal = false
                          },
                        },
                      },
                      [_vm._v("Vazgeç")]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveEdit },
                      },
                      [_vm._v("Güncelle")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editModal && _vm.field === "preferredLang"
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Tercih Edilen Dili Güncelle",
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c("UpdateContactLang", {
                attrs: { contact: _vm.contact },
                on: {
                  close: function ($event) {
                    _vm.editModal = false
                  },
                  save: _vm.savePreferredLang,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editModal && _vm.field === "tags"
        ? _c(
            "Modal2",
            {
              attrs: { title: "Etiketleri Güncelle", showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c("TagDialog", {
                attrs: { value: _vm.getContactTagIds(), inlineMode: true },
                on: {
                  input: _vm.saveTagsUpdate,
                  close: function ($event) {
                    _vm.editModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editModal && _vm.field === "email"
        ? _c(
            "Modal2",
            {
              attrs: { title: "E-posta Güncelle", showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.editModal = false
                },
              },
            },
            [
              _c("div", { attrs: { id: "contact-property-modal-content" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedValue,
                      expression: "editedValue",
                    },
                  ],
                  attrs: { type: "email", placeholder: "Yeni e-posta girin" },
                  domProps: { value: _vm.editedValue },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.editedValue = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                !_vm.editedValue.includes("@")
                  ? _c(
                      "div",
                      { staticClass: "email-suggestions" },
                      _vm._l(_vm.emailDomains, function (domain) {
                        return _c(
                          "span",
                          {
                            key: domain,
                            on: {
                              click: function ($event) {
                                return _vm.appendEmailDomain(domain)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.editedValue) +
                                _vm._s(domain) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        on: {
                          click: function ($event) {
                            _vm.editModal = false
                          },
                        },
                      },
                      [_vm._v("Vazgeç")]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveEdit },
                      },
                      [_vm._v("Güncelle")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addModal
        ? _c(
            "Modal2",
            {
              attrs: { title: "Ekle: " + _vm.label, showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.addModal = false
                },
              },
            },
            [
              _c("div", { attrs: { id: "contact-property-modal-content" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newValue,
                      expression: "newValue",
                    },
                  ],
                  attrs: { placeholder: "Yeni değer girin" },
                  domProps: { value: _vm.newValue },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newValue = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        on: {
                          click: function ($event) {
                            _vm.addModal = false
                          },
                        },
                      },
                      [_vm._v("Vazgeç")]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveAdd },
                      },
                      [_vm._v("Ekle")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteModal
        ? _c(
            "Modal2",
            {
              attrs: { title: "Silme Onayı", showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.deleteModal = false
                },
              },
            },
            [
              _c("div", { attrs: { id: "contact-property-modal-content" } }, [
                _c("p", [
                  _vm._v("Bu özelliği silmek istediğinizden emin misiniz?"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        on: {
                          click: function ($event) {
                            _vm.deleteModal = false
                          },
                        },
                      },
                      [_vm._v("Vazgeç")]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmDelete },
                      },
                      [_vm._v("Evet, Sil")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }